import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_application.svg'


const _withScopeId = n => (_pushScopeId("data-v-50c29fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "logo",
  height: "16"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user menu-icon" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-briefcase menu-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-briefcase-blank menu-icon" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-building menu-icon" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-folder menu-icon" }, null, -1))
const _hoisted_8 = { class: "crm-item__container" }
const _hoisted_9 = { class: "crm-item__left" }
const _hoisted_10 = { class: "crm-badge-photo" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "crm-item__center" }
const _hoisted_13 = { class: "crm-item__title" }
const _hoisted_14 = { class: "crm-item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.isMenuVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isMenuVisible) = $event)),
    direction: "ltr"
  }, {
    default: _withCtx(() => [
      _createElementVNode("aside", null, [
        _createElementVNode("header", _hoisted_1, [
          _createElementVNode("i", {
            class: "fal fa-times close-menu-icon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _hoisted_2
        ]),
        _createVNode(_component_el_menu, {
          router: true,
          "default-active": _ctx.mainPath
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, {
              index: "contact",
              route: { name: 'contact' },
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Sidebar.ContactMenuLabel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_menu_item, {
              index: "business",
              route: { name: 'business' },
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Sidebar.BusinessMenuLabel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_menu_item, {
              index: "lead",
              route: { name: 'lead' },
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Sidebar.LeadMenuLabel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_menu_item, {
              index: "account",
              route: { name: 'account' },
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Sidebar.AccountMenuLabel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.isProjectMenuVisible)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: "project",
                  route: { name: 'project' },
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Sidebar.ProjectMenuLabel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["default-active"]),
        _createElementVNode("footer", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  alt: "photo",
                  src: _ctx.$oidc.userProfile.picture
                }, null, 8, _hoisted_11)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$oidc.userProfile.name), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: _ctx.logout
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Sidebar.SignOutMenu")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}